<template>
    <!-- 目的地 -->
    <div class="destination-search-form search-form-container" :class="{'f-dn': !isShow}" data-key="DestinationCode">
        <div class="search-form-country">
            <div v-for="(subCategory, index) in hpGroupSubCategories" :key="index" 
                class="search-form-country-item" 
                :class="{ active: index == currentGroupIndex, 'search-form-country-item-large': subCategory.length >= 7}"
                :data-area="subCategory"
                @click="changeGroup(index)">
                {{subCategory}}
            </div>

        </div>

        <div v-for="(subCategory, index) in hpGroupSubCategories" :key="index" 
            class="search-form-item-container row" 
            :class="{ active: index == currentGroupIndex }"
            :data-area="subCategory">
            
            <DestinationGroupForm :cruiseType="cruiseType" 
            :groups="getFilterGroups(destinations, subCategory)"
            :destinations="destinations" 
            :subCategory="subCategory"/>
        </div>


        <div class="search-form-clear" @click="onDestinationClear()">
            <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-clear.png" />
            <span>清空全部</span>
        </div>

    </div>
</template>

<script>
const DestinationGroupForm = () => import('@/components/SearchBar/DestinationGroupForm')

export default {
    name: 'DestinationForm',
    components: {
        DestinationGroupForm
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        }
    },
    data () {
        return {
            currentGroupIndex: 0
        }
    },
    methods: {
        getFilterGroups (destinations, subCategory) {
            let groups = []
            destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupSubCategory == subCategory 
                    && destination.countryName && destination.countryName.length > 0) {
                        const groupName = destination.cruiseFilterGroupName
                        if (!groups.includes(groupName)) {
                            groups.push(groupName)
                        }
                    }
            })
            return groups
        },
        changeGroup (index) {
            this.currentGroupIndex = index
        },
        onDestinationClear () {
            this.$store.dispatch('RESET_DESTINATION_FILTERS', { cruiseType: this.cruiseType })
        },
        
        getDestinationsBySubCategory (subCategory) {
            return this.destinations.filter(item => item.cruiseFilterGroupSubCategory == subCategory)
        },
    },
    computed: {
        hpGroupSubCategories () {
            let groupSubCategories = []
            this.destinations.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupSubCategory
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })

            return groupSubCategories
        },
        filterResponseDesinations () {
            return this.$store.state.cruise.filterResponse[this.cruiseType].destinations
        },
    },
    watch: {
        filterResponseDesinations (newOne) {
            // 查找第一个可以选择的sub category
            let availableIndexs = []
            const availableItems = newOne
            this.hpGroupSubCategories.forEach((subCategory, i) => {
                const destinationCodes = this.getDestinationsBySubCategory(subCategory).map(item=>item.filterCode)
                let isNotDisbaleAll = availableItems.some(item=> destinationCodes.includes(item))
                if (isNotDisbaleAll) {
                    availableIndexs.push(i)
                }
            })
            if (availableIndexs.length > 0 && !availableIndexs.includes(this.currentGroupIndex)) {
                this.currentGroupIndex = availableIndexs[0]
            }

        }
    }
}
</script>
